import { useLocaleStore } from 'stores/locale-store'

export function useAppUrls() {
  const localeStore = useLocaleStore()
  const SITE_URL = import.meta.env.VITE_REDIRECT_URI?.replace(/\/$/, '') || ''

  const getLangPath = () => {
    return localeStore.locale === 'el-GR' ? 'el' : 'en'
  }

  const createUrl = (path: string, absolute = true) => {
    const lang = getLangPath()
    const cleanPath = path.startsWith('/') ? path : `/${path}`
    const localizedPath = `/${lang}${cleanPath}`

    return absolute ? `${SITE_URL}${localizedPath}` : localizedPath
  }

  const getProgramUrl = (id: string | number, type: string, slug?: string, absolute = true) => {
    const slugPart = slug ? `/${slug}` : ''
    return createUrl(`/programmes/${type}/${id}/details${slugPart}`, absolute)
  }

  const getUniversityUrl = (id: string | number, absolute = true) => {
    return createUrl(`/universities/${id}/details`, absolute)
  }

  return {
    createUrl,
    getProgramUrl,
    getUniversityUrl,
    getLangPath,
    SITE_URL,
  }
}
